export interface VSelectToggleState {
  shouldPreventClick: boolean;
  selectRef: any;
  getSelectRef?: () => any;
}

function isInteractiveIcon(target: HTMLElement, inputSlot: HTMLElement): boolean {
  const iconEl = target.closest('.v-input__icon');
  if (!iconEl) return false;
  return inputSlot.contains(iconEl);
}

export function createVSelectToggleHandlers(state: VSelectToggleState) {
  const getSelectComponent = () => {
    if (state.getSelectRef) {
      return state.getSelectRef();
    }
    return state.selectRef?.value || state.selectRef;
  };
  const removeEventListeners = (inputSlot: HTMLElement) => {
    inputSlot.removeEventListener('mousedown', handleMouseDown, true);
    inputSlot.removeEventListener('mouseup', handleMouseUp, true);
    inputSlot.removeEventListener('click', handleClick, true);
  };

  const handleMouseDown = (event: MouseEvent) => {
    const target = event.target as HTMLElement;
    const selectComponent = getSelectComponent();
    if (selectComponent && selectComponent.isMenuActive) {
      const inputSlot = selectComponent.$el?.querySelector('.v-input__slot') as HTMLElement | null;
      if (inputSlot && isInteractiveIcon(target, inputSlot)) {
        state.shouldPreventClick = false;
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      state.shouldPreventClick = true;
      selectComponent.isMenuActive = false;
    } else {
      state.shouldPreventClick = false;
    }
  };

  const handleMouseUp = (event: MouseEvent) => {
    if (state.shouldPreventClick) {
      event.preventDefault();
      event.stopPropagation();
    }
  };

  const handleClick = (event: MouseEvent) => {
    if (state.shouldPreventClick) {
      event.preventDefault();
      event.stopPropagation();
      state.shouldPreventClick = false;
    }
  };

  const attachListeners = () => {
    setTimeout(() => {
      const selectComponent = getSelectComponent();
      if (selectComponent && selectComponent.$el) {
        const inputSlot = selectComponent.$el.querySelector('.v-input__slot');
        if (inputSlot) {
          inputSlot.addEventListener('mousedown', handleMouseDown, true);
          inputSlot.addEventListener('mouseup', handleMouseUp, true);
          inputSlot.addEventListener('click', handleClick, true);
        }
      }
    }, 100);
  };

  const detachListeners = () => {
    const selectComponent = getSelectComponent();
    if (selectComponent && selectComponent.$el) {
      const inputSlot = selectComponent.$el.querySelector('.v-input__slot');
      if (inputSlot) {
        removeEventListeners(inputSlot);
      }
    }
  };

  return {
    attachListeners,
    detachListeners,
  };
}
